/**
 * External ID pattern: 2-4 lowercase prefix, underscore, Base58 encoded string.
 * Examples: acc_3Yp7mKxJv2hNqRs9tUwX8Z, gw_5Kp2nLxQw3jMrTs8vYwA7B
 */
const EXTERNAL_ID_REGEX = /^[a-z]{2,4}_[1-9A-HJ-NP-Za-km-z]{10,30}$/;

/**
 * Check if a string looks like an external ID (prefix_base58).
 */
export function isExternalIdFormat(id: string): boolean {
  return EXTERNAL_ID_REGEX.test(id);
}

/**
 * Format an ID for display.
 * - External IDs (prefix_xxxx): show prefix + first `len` chars of encoded part
 * - UUIDs: show first `len` characters
 * - Null/undefined: return empty string
 */
export function formatId(id: string | null | undefined, len = 8): string {
  if (!id) return "";

  if (isExternalIdFormat(id)) {
    const underscoreIdx = id.indexOf('_');
    const prefix = id.slice(0, underscoreIdx + 1); // includes underscore
    const encoded = id.slice(underscoreIdx + 1);
    if (encoded.length <= len) return id; // short enough to show full
    return `${prefix}${encoded.slice(0, len)}`;
  }

  return id.slice(0, len);
}
